import React from 'react';

import { ExternalLink } from 'features/order-tracker/shared-components';
import {
  ORDER_STATUS_MESSAGE,
} from './constants';

import styles from './style.module.scss';

export const Message: React.FC<components.MessageProps> = ({ orderStatus }) => (
  <p>{ORDER_STATUS_MESSAGE[orderStatus].text}
    {ORDER_STATUS_MESSAGE[orderStatus].linkUrl && (
      <ExternalLink
        link={ORDER_STATUS_MESSAGE[orderStatus].linkUrl!}
        text={ORDER_STATUS_MESSAGE[orderStatus].linkText!}
        className={styles.link}
        withIcon={false}
      />
    )}
    {ORDER_STATUS_MESSAGE[orderStatus].endText}
  </p>
);
